import { render, staticRenderFns } from "./PanelWithExpenseDetail.vue?vue&type=template&id=b97cf844&lang=pug&"
import script from "./PanelWithExpenseDetail.vue?vue&type=script&lang=ts&"
export * from "./PanelWithExpenseDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithExpenseDetail.vue?vue&type=style&index=0&id=b97cf844&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports